export default __webpack_public_path__ + "1bd129453d661e1435d47074cbbd7e0a.png";